<template>
	<div class="step">
		<div class="login-wrapper" v-if="!preAuthenticate">
			<SubHeader/>
			<div class="container">
				<div class="row">
					<form action="#" method="post" @submit.prevent="submit" class="col-md-7 mx-auto py-5">
						<div class="row mt-3 pt-3">
							<div class="col-6">
								<div class="form-field">
									<label for="firstName" class="form-label">First Name</label>
									<input type="text" class="form-control" name="firstName" id="firstName" v-model="firstName" placeholder="Enter your first name" required>
								</div>
							</div>
							<div class="col-6">
								<div class="form-field">
									<label for="lastName" class="form-label">Last Name</label>
									<input type="text" class="form-control" name="lastName" id="lastName" v-model="lastName" placeholder="Enter your last name" required>
								</div>
							</div>
						</div>
						<div class="form-field mt-3 pt-3">
							<label for="phone" class="form-label">Phone</label>
							<input type="text" class="form-control" name="phone" id="phone" v-model="phone" placeholder="201-555-0123" required>
						</div>
						<div class="form-field mt-3 pt-3">
							<label for="email" class="form-label">Email</label>
							<input type="email" class="form-control" name="email" id="email" v-model="email" placeholder="Your email address here" required>
						</div>
                        <div class="form-field mt-3 pt-3">
                            <label for="password" class="form-label">Password</label>
                            <div class="password-field">
                                <input :type="(showPassword ? 'text' : 'password')" class="form-control" name="password" id="password" v-model="password" placeholder="Choose a strong password" required>
                                <button type="button" @click="showPassword = !showPassword" tabindex="-1">
                                    <img src="../assets/icons/eye.png" alt="Eye">
                                </button>
                            </div>
                            <div class="password-errors mt-3" v-if="showErrors">
                                <p class="text-danger fw-bolder small m-0" v-if="password && password.length < 8">Password should be at least 8 characters</p>
                                <p class="text-danger fw-bolder small m-0" v-if="!matchRegex(password, /[A-Z]/)">Add at least one uppercase character (A-Z)</p>
                                <p class="text-danger fw-bolder small m-0" v-if="!matchRegex(password, /[a-z]/)">Add at least one lowercase character (a-z)</p>
                                <p class="text-danger fw-bolder small m-0" v-if="!matchRegex(password, /[0-9]/)">Add at least one numeric character (0-9)</p>
                            </div>
                            <p class="small col-md-8 fst-italic text-muted mt-3">Password should be at least 8 characters, contain an uppercase character, a lowercase character, a number and a symbol.</p>
                        </div>
                        <div class="password-errors mt-3" v-if="error">
                            <p class="text-danger fw-bolder small m-0" v-if="error === 'missing_data'">Please enter email and password.</p>
                            <p class="text-danger fw-bolder small m-0" v-if="error === 'account_auth_failed'">You already have an account. Please enter your correct email and password.<br>If you have forgotten your password, you can <a :href="resetPasswordLink" class="text-brand">reset your password</a>.</p>
                        </div>

						<!-- Form Navigation -->
						<div class="d-flex flex-column flex-md-row justify-content-md-between mt-3">
							<button class="btn btn-primary btn-wide ms-md-auto" type="submit" :disabled="loading">
								<span class="spinner-border" v-if="loading"></span>
								<span :class="{'opacity-0': loading}">Continue</span>
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div class="loading-effect py-5 text-center" v-if="preAuthenticate">
			<div class="spinner-border text-black-50 opacity-25"></div>
		</div>
	</div>
</template>

<script>
import SubHeader from "@/components/SubHeader.vue";
import repository from "@/repository/repository";
import Logs from "@/repository/logs";
import {PORTAL_URL} from "@/main";

export default {
    name: "AuthForm",
    components: {SubHeader},
    beforeMount() {
        if(this.$store.getters.auth.completed) {
            this.$router.replace("/details");
        }
    },
    props: ['preAuthenticate',],
	data() {
        return {
            token: this.$store.getters.token,
            firstName: this.$store.getters.auth.firstName,
            lastName: this.$store.getters.auth.lastName,
            phone: this.$store.getters.auth.phone,
            email: this.$store.getters.auth.email,
            password: null,
            showPassword: false,
            error: null,
            showErrors: false,
			loading: false,
		}
	},
	created() {
        if(this.$store.getters.auth.completed) {
            this.$router.push("/details");
		}
        if(this.preAuthenticate) {
            // Verify if user is already signed in
            repository.get("/me", {
                headers: {
                    'Authorization': 'Bearer ' + this.preAuthenticate,
                }
            })
                .then(response => {
                    this.$store.commit("updateAuth", {
                        token: this.preAuthenticate,
                    });
                    this.$store.commit("updateAll", response.data.user);
                    this.$store.commit("setPreAuthenticated");
                    this.$router.replace("/details");
                })
                .catch(error => {
                    this.$store.commit("logoutUser");
                    this.$router.replace("/");
                    Logs.save('onboarding.authForm.preAuthenticate', error.response, null);
                })
        }
	},
    methods: {
        submit() {
            // Verify Password
            if(!this.checkPassword()) {
                this.showErrors = true;
                return false;
            }

            // Start Loading Effect
            this.loading = true;
            this.error = false;

            // Prepare input fields
            this.firstName = this.prepareNameField(this.firstName);
            this.lastName = this.prepareNameField(this.lastName);

            // Submit Request & Proceed
			let payload = {
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                password: this.password,
            };

            // Submit for authentication
            repository.post('/auth', payload)
                .then(response => {

                    // Save new lead on Google Tag
                    this.$gtag.event('onboarding_new_lead');
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'onboarding_new_lead',
                    });

                    // This is new account, store the token and continue
                    if(response.data.code === 'account_created') {
                        this.$store.commit("updateAuth", {
                            token: response.data.token,
                            email: this.email,
                            password: this.password,
                            firstName: this.firstName,
                            lastName: this.lastName,
                            phone: this.phone,
                        });
                    }

                    // This is old account, we may already have some data
                    if(response.data.code === 'account_found') {
                        this.$store.commit("updateAuth", {
                            token: response.data.token,
                            email: this.email,
                            password: this.password,
                            firstName: this.firstName,
                            lastName: this.lastName,
                            phone: this.phone,
                        });
                        this.$store.commit("updateAll", response.data.user);
                        if(this.$store.getters.review.finished) {
                            this.$router.replace("/already-completed");
                            return;
                        }
                    }

                    this.loading = false;
                    this.$router.push("/details");
                })
                .catch(error => {
                    console.log(error);
                    this.error = error.response.data.code;
                    this.loading = false;
                    Logs.save('onboarding.authForm', error.response, payload);
                })

            // repository.post('/lead', payload)
			// 	.then(response => {
            //         this.$store.commit("updateLead", {
            //             email: this.email,
            //             firstName: this.firstName,
            //             lastName: this.lastName,
            //             phone: this.phone,
            //         });
            //         this.loading = false;
            //
            //         this.$gtag.event('onboarding_new_lead');
            //         window.dataLayer = window.dataLayer || [];
            //         window.dataLayer.push({
            //             'event': 'onboarding_new_lead',
            //         });
            //
            //         this.$router.push("/personal");
            //
            //         // An error happened, but ignore it and continue
            //         if(response.data.status === 'error') {
            //             Logs.save('onboarding.authForm', response.data, payload);
            //         }
			// 	})
			// 	.catch(error => {
            //         this.error = error.response.data.code;
            //         this.loading = false;
            //         Logs.save('onboarding.authForm', error.response, payload);
			// 	})
		},
        matchRegex(input, regex) {
            return regex.test(input);
        },
        checkPassword() {
            if(!this.password) return false;
            if(this.password.length < 8) return false;
            if(!this.matchRegex(this.password, /[A-Z]/)) return false;
            if(!this.matchRegex(this.password, /[a-z]/)) return false;
            return this.matchRegex(this.password, /[0-9]/);
        },
        prepareNameField(value) {
            return value.replace(/[^A-Za-z ]/gi, '');
        },
	},
    computed: {
        resetPasswordLink() {
            return PORTAL_URL + "/forgot-password";
        },
    },
    watch: {
        birthday(newValue, oldValue) {
            console.log(newValue, oldValue);
        }
    },
}
</script>

<style lang="scss">
.password-field {
	position: relative;

	button {
		position: absolute;
		bottom: 0;
		right: 0;
		top: 0;
		margin: auto;
		background: none;
		border: none;
		box-shadow: none;
		outline: none;
		width: 3rem;
		height: 3rem;
		padding: 0.25rem;
		opacity: 0.25;
		transition: 0.2s ease all;

		&:hover {
			opacity: 1;
		}

		img {
			width: 1.5rem;
		}
	}
}

.step {
	h4 {
		font-size: 1.75rem;
		font-weight: bold;
		color: #16193A;

		@media (max-width: 767px) {
			font-size: 1.25rem;
		}
	}
}
</style>